import { types } from 'mobx-state-tree';
import Modal from './Modal';

const PopoverModal = Modal.named('PopoverModal')
  .props({
    openedManually: types.optional(types.boolean, true),
  })
  .actions((self) => ({
    toggle: () => {
      self.isOpen = !self.isOpen;
    },
  }));

export default PopoverModal;
